import { BebopChain } from "../types/chain";
import { CHAINS, SUPPORTED_CHAINS } from "config/chains";
import { Chain } from "@rainbow-me/rainbowkit";
import { mainnet } from "viem/chains";
import { IGlobalStore } from "../store/global/GlobalStore";
import { Address } from "viem";

export const getChainIdFromName = (name: string): number => {
  const found = SUPPORTED_CHAINS.find(chain => {
    return chain.name.toLowerCase() === name.toLowerCase();
  });
  if (found) {
    return found.id;
  }

  throw new Error(`Could not find ID for chain name '${name}'`);
};

export const getChainFromName = (name: string): BebopChain | undefined => {
  return SUPPORTED_CHAINS.find(chain => chain.name.toLowerCase() === name.toLowerCase());
};
export const getChainFromId = (id: number): BebopChain | undefined => {
  return SUPPORTED_CHAINS.find(chain => Number(chain.id) === Number(id));
};

export const getWrappedTokenAddress = (chain: Chain): Address => {
  return CHAINS[chain.id].wrappedTokenAddress;
};

export const isEthereumNetwork = (network: Chain): boolean => {
  return network.id === mainnet.id;
};

export const getBlockExplorerForNetwork = (network: Chain): string => {
  const chainConfig = CHAINS[network.id];
  if (chainConfig) {
    return chainConfig.blockExplorerUrl;
  }
  return "";
};

export const isStoredNetworkOutOfSync = (
  storedNetwork: IGlobalStore["network"],
  walletNetworkId: Chain | undefined
) => {
  return storedNetwork.id !== walletNetworkId?.id;
};
